/* app/js/src/components/channel/platforms/custom/custom-platform.component.scss */
.cursor-pointer {
  cursor: pointer;
}
section textarea::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
section textarea::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
section textarea::-webkit-scrollbar-corner {
  background: transparent;
}
section textarea::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
section textarea::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
section textarea::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
section textarea::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
section textarea::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
section input {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border-radius: 4px;
  background-color: #ffffff;
  height: 30px;
  border: 1px solid #e1e6eb;
  line-height: 2.2em;
  font-size: 0.9em;
  padding: 0 15px;
  color: #232f3a;
}
section input:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
section input::-webkit-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
section input:-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
section input::-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
section input:-ms-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
section input.ng-invalid.ng-dirty,
section input.ng-invalid.ng-touched {
  border-color: #ef5350;
}
.cursor-pointer {
  cursor: pointer;
}
section textarea::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
section textarea::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
section textarea::-webkit-scrollbar-corner {
  background: transparent;
}
section textarea::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
section textarea::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
section textarea::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
section textarea::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
section textarea::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
section input {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border-radius: 4px;
  background-color: #ffffff;
  height: 30px;
  border: 1px solid #e1e6eb;
  line-height: 2.2em;
  font-size: 0.9em;
  padding: 0 15px;
  color: #232f3a;
}
section input:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
section input::-webkit-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
section input:-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
section input::-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
section input:-ms-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
section input.ng-invalid.ng-dirty,
section input.ng-invalid.ng-touched {
  border-color: #ef5350;
}
.srt-port-number {
  display: inline-block;
}
section {
  margin-bottom: 25px;
}
section header {
  font-size: 14px;
  margin-bottom: 25px;
  line-height: 14px;
}
section div {
  font-size: 12px;
  line-height: 12px;
}
section .label {
  color: #879baf;
  display: inline-block;
  margin-right: 15px;
}
section .label.textarea-label {
  position: relative;
  top: -69px;
}
section input.push-format-input {
  width: 279px;
}
section input[type=number]::-webkit-outer-spin-button,
section input::-webkit-inner-spin-button {
  position: relative;
  right: -15px;
  height: 20px;
  line-height: 30px;
}
section .hls-settings {
  display: inline-block;
  margin-right: 12px;
  font-size: 14px;
}
section .hls-settings > div {
  display: block;
}
section .hls-settings .label {
  margin-bottom: 14px;
}
section .hls-settings:nth-child(4) {
  margin: 0;
}
section textarea {
  border-radius: 4px;
  background-color: #ffffff;
  width: 301px;
  height: 89px;
  resize: none;
  font-size: 12px;
  line-height: 15px;
  padding: 5px 10px 0 10px;
  border: solid 1px #e1e6eb;
  color: #232f3a;
  outline: none;
  margin-top: 25px;
}
section textarea ::-webkit-input-placeholder {
  color: #c9cdd6;
}
section .codec-dropdown {
  width: 221px;
  display: inline-block;
  margin-top: 16px;
}
section .codec-dropdown div {
  display: block;
  cursor: pointer;
  color: #879baf;
  height: 30px;
  line-height: 30px;
}
section .codec-dropdown div.clickable {
  text-decoration: underline;
}
section .codec-dropdown div.new {
  color: #232f3a;
  padding-left: 31px;
}
section .codec-dropdown div.new:hover {
  background-color: #eef2f6;
}
section .codec-dropdown div.inline {
  display: inline-block;
}
.subtitles-choose,
.audio-choose,
.edge-servers-choose {
  display: flex;
  flex-grow: 1;
  flex-basis: 100%;
  margin-bottom: 10px;
}
.subtitles-choose icn-dropdown,
.audio-choose icn-dropdown,
.edge-servers-choose icn-dropdown {
  flex-grow: 1;
}
.label,
.srt-field {
  color: #879baf;
  font-size: 12px;
  line-height: 33px;
  margin-right: 25px;
}
.subtitles-font-popover {
  width: 365px;
  min-height: 250px;
  height: auto;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px #e1e6eb;
  padding: 19px;
}
.subtitles-font-popover header {
  font-family: "Open Sans";
  font-size: 20px;
  font-weight: bold;
}
.subtitles-font-popover .field {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.subtitles-font-popover .field .label {
  line-height: 30px;
}
.subtitles-font-popover .field .number-input {
  width: 120px;
  display: inline-flex;
}
.subtitles-font-popover ichannel-button {
  align-self: flex-end;
  margin-top: 10px;
}
.subs-settings {
  width: 371.9px;
  height: 180px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px #e1e6eb;
  padding: 19px;
}
.subs-settings header {
  font-size: 20px;
  margin-bottom: 13px;
}
.subs-settings .x-sign {
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
}
.triangle-with-shadow {
  width: 17px;
  height: 20px;
  position: absolute;
  overflow: hidden;
  left: -15px;
  top: 66px;
  background-color: transparent;
}
.triangle-with-shadow:after {
  content: "";
  position: absolute;
  width: 20px;
  height: 20px;
  transform: rotate(-45deg);
  left: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
}
.settingIcon {
  position: relative;
  display: inline;
  top: 3px;
  left: 11px;
  cursor: pointer;
}
.settingIcon ::ng-deep svg {
  width: 13px;
  height: 13px;
}
.settingIcon ::ng-deep svg path {
  fill: #40c4ff !important;
}
.header-close-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 28px;
}
.srt-settings {
  width: max-content;
}
.srt-settings > div {
  line-height: 30px;
}
.align-middle {
  vertical-align: middle;
}
.cursor-pointer {
  cursor: pointer;
}
.srt-field .label {
  width: 100px;
}
/*# sourceMappingURL=custom-platform.component.css.map */
